import React, { useContext } from 'react';

import { Context } from '../Context/StoreLocatorContext';
import StoreHours from '../StoreHours/StoreHours';
import NearbyStores from '../NearbyStores/NearbyStores';
import useActiveStore from '../../../hooks/useActiveStore';
import isKiosk from '../../../utils/isKiosk';
import useFeatureFlag from '../../FeatureFlag/useFeatureFlag';
import { FeatureFlags } from '../../FeatureFlag/featureFlags';

const StoreInformation = () => {
  const data = useContext(Context);
  const { activeStore } = useActiveStore();
  const {
    origin,
    nearbyStores,
    allStoreLogos,
    setInputRef,
    showSelectBtn,
    scrollToTop,
    hideBookAppointment,
  } = data;
  const isKioskMode = isKiosk();
  const isBookAppointmentFFEnabled = useFeatureFlag(FeatureFlags.BookAppointment);
  return (
    <>
      {activeStore && (
        <StoreHours
          origin={origin}
          allStoreLogos={allStoreLogos}
          storeToDisplay={activeStore}
          showSelectBtn={showSelectBtn}
          hideBookAppointment={
            isKioskMode || !isBookAppointmentFFEnabled || hideBookAppointment
          }
          hideDirections={isKioskMode}
        />
      )}
      {nearbyStores && !isKioskMode && (
        <NearbyStores
          nearbyStores={nearbyStores}
          allStoreLogos={allStoreLogos}
          setInputRef={setInputRef}
          scrollToTop={scrollToTop}
        />
      )}
    </>
  );
};

export default StoreInformation;
